const toLocale = v => {
  if (typeof v !== "number") return "";

  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export default toLocale;
